export const BOOKINGS_APP_DEF_ID = '13d21c63-b5ec-5912-8397-c3a5ddb27a97';
export const BOOKINGS_SERVICE_PAGE_SECTION_ID = 'Booking Service Page';
export const BOOKINGS_CHECKOUT_SECTION_ID = 'book_checkout';
export const BOOKINGS_SCHEDULER_SECTION_ID = 'scheduler';
export const BOOKINGS_CALENDAR_SECTION_ID = 'Booking Calendar';
export const PRICING_PLAN_APP_DEF_ID = '1522827f-c56c-a5c9-2ac9-00f9e6ae12d3';
export const PRICING_PLAN_SECTION_ID = 'membership_plan_picker_tpa';
export const BOOKINGS_LIST_SECTION_ID = 'bookings_list';
export const CONTEXT_BOOK_ONLINE_SECTION_ID = 'bookingsBookOnline';
export const CONTEXT_CALENDAR_SECTION_ID = 'bookingsCalendar';
export const BOOKINGS_FORM_SECTION_ID = 'Booking Form';
export const ECOM_APP_DEF_ID = '1380b703-ce81-ff05-f115-39571d94dfcd';
export const ECOM_CART_SECTION_ID = 'shopping_cart';
export const SANTA_MEMBERS_APP_ID = '14cc59bc-f0b7-15b8-e1c7-89ce41d0e0c9';
export const BOOKINGS_MEMBERS_AREA_WIDGET_ID = '14edb332-fdb9-2fe6-0fd1-e6293322b83b';
export const MEMBERS_AREA_SECTION_ID = 'bookings_member_area';
export const CALENDAR_PAGE_URL_PATH_PARAM = 'booking-calendar';
export let BookingsQueryParams = /*#__PURE__*/function (BookingsQueryParams) {
  BookingsQueryParams["REFERRAL"] = "referral";
  BookingsQueryParams["STAFF"] = "staff";
  BookingsQueryParams["LOCATION"] = "location";
  BookingsQueryParams["BOOKING_ID"] = "bookingId";
  BookingsQueryParams["SERVICE_ID"] = "service";
  BookingsQueryParams["AVAILABILITY_SLOT"] = "slot";
  BookingsQueryParams["TIMEZONE"] = "timezone";
  BookingsQueryParams["DYNAMIC_PRICING"] = "dynamic-pricing";
  BookingsQueryParams["FILLED_FIELDS"] = "filledFields";
  BookingsQueryParams["PUBLIC_DATA_OVERRIDES"] = "publicDataOverrides";
  BookingsQueryParams["ECOM"] = "ecom";
  BookingsQueryParams["CONTINUE_SHOPPING_URL"] = "continueShoppingUrl";
  BookingsQueryParams["DATE"] = "date";
  BookingsQueryParams["RESOURCE"] = "resource";
  BookingsQueryParams["CATEGORY"] = "category";
  BookingsQueryParams["PAGE"] = "page";
  BookingsQueryParams["TIME"] = "time";
  BookingsQueryParams["TOKEN"] = "token";
  BookingsQueryParams["FLOW_DATA"] = "b";
  BookingsQueryParams["REQUESTED_GENDER"] = "requestedGender";
  return BookingsQueryParams;
}({});

/**
 * Conductor spec gating the encoded flow-data `b=` param: the service list /
 * service page encode the booking preferences into it and the calendar decodes
 * them. Defined under the bookings app scope so both bundles evaluate it
 * consistently for a visitor. Decode is total and falls back to current
 * behaviour, so a mismatch is safe.
 */
export const FLOW_DATA_IN_URL_SPEC = 'bookingsCalendarOOIflowDataInUrl';
export let Referrals = /*#__PURE__*/function (Referrals) {
  Referrals["BOOKINGS_FORM_WIDGET_WITH_CART"] = "bookings_form_widget_with_cart";
  Referrals["STANDALONE_MANAGE"] = "manage_booking_standalone_page";
  return Referrals;
}({});
export let BookingsBOLink = /*#__PURE__*/function (BookingsBOLink) {
  BookingsBOLink["CALENDAR"] = "calendar";
  BookingsBOLink["SERVICES"] = "services";
  BookingsBOLink["ADD_NEW_SERVICE"] = "services/templates-catalog";
  BookingsBOLink["AVAILABILITY"] = "availability";
  BookingsBOLink["SETTINGS"] = "settings";
  BookingsBOLink["SHARABLE_LINKS"] = "dashboard";
  BookingsBOLink["INTEGRATIONS"] = "integrations";
  BookingsBOLink["BOOK_FLOW_CUSTOMIZE"] = "settings/bookflow-settings";
  return BookingsBOLink;
}({});
//# sourceMappingURL=const.js.map